// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/thinking_square.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/thinking_square_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/thinking_square_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageInput_textarea_box__uyZ8D {
    position: relative;
    width: 100%;
    padding: 10px 40px 50px 40px;
    font-size: 16px;
    border: 1px solid #c3c7cf;
    border-radius: 6px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}

.MessageInput_textarea_box__uyZ8D:hover,
.MessageInput_textarea_box__uyZ8D:focus-within,
.MessageInput_textarea_box__uyZ8D:focus {
    border-color: #17a8b5;
}

.MessageInput_textarea_image__kAfIE {
    padding: 80px 40px 50px 40px;
}

.MessageInput_custom_textarea__i4l1w {
    /* width: 100%;
    height: 100% !important;
    min-height: 48px !important;
    max-height: 100% !important;
    padding-right: 40px;
    overflow-y: auto */
    /* min-height: 48px !important; */
    /* padding: 10px 35px 46px 10px; */
    /* background-color: #f9f9f9; */
    min-height: 50px !important;
    /* padding: 10px 35px 46px 46px;
    font-size: 16px;
    border: 1px solid #c3c7cf;
    border-radius: 6px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); */
    padding: 0 5px 0 0 !important;
    border: none;
}

.MessageInput_custom_textarea__i4l1w:hover,
.MessageInput_custom_textarea__i4l1w:focus-within,
.MessageInput_custom_textarea__i4l1w:focus {
    border: none !important;
    box-shadow: none !important;
    /* border-color: #17a8b5; */
}

/* 自定义滚动条 */
.MessageInput_custom_textarea__i4l1w::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.MessageInput_custom_textarea__i4l1w::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MessageInput_custom_textarea__i4l1w::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
    cursor: default;
}

.MessageInput_send_butn_img__vel6T {
    position: absolute;
    right: 10px;
    /* top: 15px; */
    bottom: 75px;
    cursor: pointer;
}

@keyframes MessageInput_spin__aqREM {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.MessageInput_thinking_loading_box__ZOutN {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    border-radius: 100%;
    -webkit-user-select: none;
            user-select: none;
}

.MessageInput_circle_img__imXAw {
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0px;
    top: 0px;
    animation: MessageInput_spin__aqREM 2s linear infinite;
}

.MessageInput_square_img__teS9J {
    width: 12px;
    height: 12px;
    position: absolute;
    right: 10px;
    top: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    transition: background 0.5s, box-shadow 0.5s;
}


/* 隐藏伪元素用来预加载悬停背景图 */
.MessageInput_thinking_loading_box__ZOutN::before .MessageInput_square_img__teS9J {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.MessageInput_thinking_loading_box__ZOutN::after .MessageInput_square_img__teS9J {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.MessageInput_thinking_loading_box__ZOutN:hover .MessageInput_square_img__teS9J {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / 100% 100%;
}

.MessageInput_thinking_loading_box__ZOutN:active .MessageInput_square_img__teS9J {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / 100% 100%;
}
.MessageInput_mobile_textarea_box__rwf1v .MessageInput_custom_textarea__i4l1w {
    height: 42px!important;
    min-height: 42px!important;
    line-height: 30px;
    padding: 6px 46px 6px 20px;
    font-size: 14px;
    border-radius: 20px;
}
.MessageInput_mobile_textarea_box__rwf1v .MessageInput_send_butn_img__vel6T {
    right: 20px;
    bottom: 12px;
}
.MessageInput_mobile_textarea_box__rwf1v .MessageInput_circle_img__imXAw {
    width: 24px;
    height: 24px;
}
.MessageInput_mobile_textarea_box__rwf1v .MessageInput_thinking_loading_box__ZOutN, .MessageInput_mobile_textarea_box__rwf1v .MessageInput_square_img__teS9J {
    right: 6px;
    top: 6px;
}

.MessageInput_reasoning_box__RmWVH {
    position: absolute;
    left: 10px;
    bottom: 10px;
    display: flex;
}

.MessageInput_reasoning__c6Kib {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 36px;
    border: 1px solid #c1c1c1;
    margin-right: 16px;
    border-radius: 36px;
    background-color: #f9f9f9;
    -webkit-user-select: none;
            user-select: none;
    cursor: pointer;
}

.MessageInput_reasoning__c6Kib:hover {
    background-color: #e4f0f2;
}

.MessageInput_reasoning_active__ZQ\\+Iq {
    border: 1px solid #17a8b5;
    color: #17a8b5;
    background-color: #e4f0f2;
}

.MessageInput_reasoning_img__3LU7i {
    margin-right: 2px;
}

.MessageInput_reasoning_text__FdkYQ {
    font-size: 16px;
    line-height: 24px;
}

.MessageInput_material_upload_active_box__ASn-c,
.MessageInput_material_upload_box__rpm7b {
    position: absolute;
    left: 10px;
    /* top: 10px; */
    bottom: 75px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    cursor: default;
}

.MessageInput_material_upload_active_box__ASn-c {
    cursor: pointer;
}

.MessageInput_preview_image_container__5NoBO {
    position: absolute;
    left: 10px;
    top: 10px;
    width: 56px;
    height: 56px;
}

.MessageInput_preview_image_box__L3Jd4 {
    position: absolute;
}

.MessageInput_preview_close__lrjLH {
    position: absolute;
    right: -10px;
    top: -10px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 25px;
    background-color: #fff;
    cursor: pointer;
}

.MessageInput_preview_close_img__zpoUx {

}

.MessageInput_material_mode_uploading_box__cAR8L {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    padding: 10px;
    border: 1px solid #C3C7CF;
    border-radius: 6px;
}

.MessageInput_material_mode_uploading_dashed__6o6Ks {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border: 1px dashed #C3C7CF;
    border-radius: 6px;
    background-color: #f2f8f9;
}

.MessageInput_uploading_preview_image_box__YrifB {
    position: relative;
    display: inline-block;
    margin-bottom: 10px;
}

.MessageInput_uploading_preview_image__0U-\\+E {
    width: auto;
    max-height: 64px;
    display: block;
}

.MessageInput_material_mode_uploading_progress__Fu1Q6 {
    width: 40%;
    height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageInput/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,4BAA4B;IAC5B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;;;;;sBAKkB;IAClB,iCAAiC;IACjC,kCAAkC;IAClC,+BAA+B;IAC/B,2BAA2B;IAC3B;;;;6CAIyC;IACzC,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;;;IAGI,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,WAAW;AACX,yDAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,+DAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,sDAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,gFAAuF;IACvF,4CAA4C;AAChD;;;AAGA,oBAAoB;AACpB;IACI,WAAW;IACX,gFAA6F;IAC7F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gFAA8F;IAC9F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gFAA6F;AACjG;;AAEA;IACI,gFAA8F;AAClG;AACA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;AAEA;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB","sourcesContent":[".textarea_box {\n    position: relative;\n    width: 100%;\n    padding: 10px 40px 50px 40px;\n    font-size: 16px;\n    border: 1px solid #c3c7cf;\n    border-radius: 6px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n}\n\n.textarea_box:hover,\n.textarea_box:focus-within,\n.textarea_box:focus {\n    border-color: #17a8b5;\n}\n\n.textarea_image {\n    padding: 80px 40px 50px 40px;\n}\n\n.custom_textarea {\n    /* width: 100%;\n    height: 100% !important;\n    min-height: 48px !important;\n    max-height: 100% !important;\n    padding-right: 40px;\n    overflow-y: auto */\n    /* min-height: 48px !important; */\n    /* padding: 10px 35px 46px 10px; */\n    /* background-color: #f9f9f9; */\n    min-height: 50px !important;\n    /* padding: 10px 35px 46px 46px;\n    font-size: 16px;\n    border: 1px solid #c3c7cf;\n    border-radius: 6px;\n    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1); */\n    padding: 0 5px 0 0 !important;\n    border: none;\n}\n\n.custom_textarea:hover,\n.custom_textarea:focus-within,\n.custom_textarea:focus {\n    border: none !important;\n    box-shadow: none !important;\n    /* border-color: #17a8b5; */\n}\n\n/* 自定义滚动条 */\n.custom_textarea::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n    cursor: default;\n}\n\n.send_butn_img {\n    position: absolute;\n    right: 10px;\n    /* top: 15px; */\n    bottom: 75px;\n    cursor: pointer;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.thinking_loading_box {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    cursor: pointer;\n    border-radius: 100%;\n    user-select: none;\n}\n\n.circle_img {\n    width: 32px;\n    height: 32px;\n    position: absolute;\n    right: 0px;\n    top: 0px;\n    animation: spin 2s linear infinite;\n}\n\n.square_img {\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    background: url('../../../../statics/thinking_square.png') no-repeat center / 100% 100%;\n    transition: background 0.5s, box-shadow 0.5s;\n}\n\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n.thinking_loading_box::before .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box::after .square_img {\n    content: \"\";\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.thinking_loading_box:hover .square_img {\n    background: url('../../../../statics/thinking_square_hover.png') no-repeat center / 100% 100%;\n}\n\n.thinking_loading_box:active .square_img {\n    background: url('../../../../statics/thinking_square_active.png') no-repeat center / 100% 100%;\n}\n.mobile_textarea_box .custom_textarea {\n    height: 42px!important;\n    min-height: 42px!important;\n    line-height: 30px;\n    padding: 6px 46px 6px 20px;\n    font-size: 14px;\n    border-radius: 20px;\n}\n.mobile_textarea_box .send_butn_img {\n    right: 20px;\n    bottom: 12px;\n}\n.mobile_textarea_box .circle_img {\n    width: 24px;\n    height: 24px;\n}\n.mobile_textarea_box .thinking_loading_box, .mobile_textarea_box .square_img {\n    right: 6px;\n    top: 6px;\n}\n\n.reasoning_box {\n    position: absolute;\n    left: 10px;\n    bottom: 10px;\n    display: flex;\n}\n\n.reasoning {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 36px;\n    border: 1px solid #c1c1c1;\n    margin-right: 16px;\n    border-radius: 36px;\n    background-color: #f9f9f9;\n    user-select: none;\n    cursor: pointer;\n}\n\n.reasoning:hover {\n    background-color: #e4f0f2;\n}\n\n.reasoning_active {\n    border: 1px solid #17a8b5;\n    color: #17a8b5;\n    background-color: #e4f0f2;\n}\n\n.reasoning_img {\n    margin-right: 2px;\n}\n\n.reasoning_text {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.material_upload_active_box,\n.material_upload_box {\n    position: absolute;\n    left: 10px;\n    /* top: 10px; */\n    bottom: 75px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 25px;\n    height: 25px;\n    cursor: default;\n}\n\n.material_upload_active_box {\n    cursor: pointer;\n}\n\n.preview_image_container {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    width: 56px;\n    height: 56px;\n}\n\n.preview_image_box {\n    position: absolute;\n}\n\n.preview_close {\n    position: absolute;\n    right: -10px;\n    top: -10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 25px;\n    height: 25px;\n    border-radius: 25px;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.preview_close_img {\n\n}\n\n.material_mode_uploading_box {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    background-color: #ffffff;\n    padding: 10px;\n    border: 1px solid #C3C7CF;\n    border-radius: 6px;\n}\n\n.material_mode_uploading_dashed {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    border: 1px dashed #C3C7CF;\n    border-radius: 6px;\n    background-color: #f2f8f9;\n}\n\n.uploading_preview_image_box {\n    position: relative;\n    display: inline-block;\n    margin-bottom: 10px;\n}\n\n.uploading_preview_image {\n    width: auto;\n    max-height: 64px;\n    display: block;\n}\n\n.material_mode_uploading_progress {\n    width: 40%;\n    height: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textarea_box": `MessageInput_textarea_box__uyZ8D`,
	"textarea_image": `MessageInput_textarea_image__kAfIE`,
	"custom_textarea": `MessageInput_custom_textarea__i4l1w`,
	"send_butn_img": `MessageInput_send_butn_img__vel6T`,
	"thinking_loading_box": `MessageInput_thinking_loading_box__ZOutN`,
	"circle_img": `MessageInput_circle_img__imXAw`,
	"spin": `MessageInput_spin__aqREM`,
	"square_img": `MessageInput_square_img__teS9J`,
	"mobile_textarea_box": `MessageInput_mobile_textarea_box__rwf1v`,
	"reasoning_box": `MessageInput_reasoning_box__RmWVH`,
	"reasoning": `MessageInput_reasoning__c6Kib`,
	"reasoning_active": `MessageInput_reasoning_active__ZQ+Iq`,
	"reasoning_img": `MessageInput_reasoning_img__3LU7i`,
	"reasoning_text": `MessageInput_reasoning_text__FdkYQ`,
	"material_upload_active_box": `MessageInput_material_upload_active_box__ASn-c`,
	"material_upload_box": `MessageInput_material_upload_box__rpm7b`,
	"preview_image_container": `MessageInput_preview_image_container__5NoBO`,
	"preview_image_box": `MessageInput_preview_image_box__L3Jd4`,
	"preview_close": `MessageInput_preview_close__lrjLH`,
	"preview_close_img": `MessageInput_preview_close_img__zpoUx`,
	"material_mode_uploading_box": `MessageInput_material_mode_uploading_box__cAR8L`,
	"material_mode_uploading_dashed": `MessageInput_material_mode_uploading_dashed__6o6Ks`,
	"uploading_preview_image_box": `MessageInput_uploading_preview_image_box__YrifB`,
	"uploading_preview_image": `MessageInput_uploading_preview_image__0U-+E`,
	"material_mode_uploading_progress": `MessageInput_material_mode_uploading_progress__Fu1Q6`
};
export default ___CSS_LOADER_EXPORT___;
